import axios from 'axios'
import React from 'react'
import { useState } from 'react'

const bashUrl = process.env.REACT_APP_BASH_URL;

function useCategory() {
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false)

    const getCategories = async () => {
        setLoading(true)
        return await axios.get(`${bashUrl}/categories/limit`).then((response) => {
            setLoading(false)
            // setError("")
            // console.log("response: ", response.data);
            setCategories(response.data.result)

            return response.data.result
        }).catch((error) => {
            setLoading(false)
            // setSuccess("")
            // setError(error.response?.data?.msg)
            // setCustomVariant("error")
            // setSnackOpen(true)
            return []
        })
    }

    return { categories, getCategories, loading }
}

export default useCategory